export enum DISPLAY_STATE {
  INTRO = 'INTRO',
  SCOREBUG = 'SCOREBUG',
  SCOREBAR = 'SCOREBAR',
}

export interface TeamConfig {
  name?: string
  shortName?: string
  logoURL?: string
  color?: string
}

export interface MatchDataInfo {
  homeScore?: number
  awayScore?: number
}

export interface GfxImageSlot {
  slotID: number
  url: string
}

export interface GfxConfig {
  imageSlots?: GfxImageSlot[]
}

// slotId values are the shared contract across play-core, frogbox-go, and the GFX renderer.
// Slot 3 = horizontal sponsor (800×150), slot 6 = vertical sponsor (150×800).
export const GFX_SLOT_ID = {
  HORIZONTAL_BANNER: 3,
  VERTICAL_BANNER: 6,
} as const

export interface MatchData {
  homeTeamConfig?: TeamConfig
  awayTeamConfig?: TeamConfig
  matchData?: MatchDataInfo
  streamResolution?: number | string
}

// Re-export event data types
export type {
  // Sport-specific score types
  VolleyballScore,
  RacquetScore,
  BaseballScore,
  SoccerScore,
  CompetitorScore,
  // Sport-specific event state types
  BaseballEventState,
  GoalSportEventState,
  GoalSportPhase,
  EventState,
  // Display state
  DisplayStateConfig,
  ScoreBugPosition,
  // Core types
  Competitor,
  EventTheme,
  JsonMatchData,
  // Graphics config
  GfxState,
} from '@/services/jsonDataService'
